export const calculatePagesAmount = ({totalItems, itemsPerPage}) => {
  return Math.ceil(totalItems / itemsPerPage);
};
